import React, { useState, useEffect, useRef } from 'react';
import { req, reqPoll, toErrorMessage } from './ServerUtils';
import { Alert, Box, Button, CircularProgress, MenuItem, Select, TextField, Menu } from '@mui/material';
import AiSubjectChooser from './AiSubjectChooser';
import { TemplateGallery } from './TemplateSelectorModalInfinite';
import { NavBar } from './Navbar';
import { PostLoginModal } from './PostLoginModal';
import { useUser } from './UserProvider';
import { Palette } from './PaletteDisplay';
import { toRgb } from './Brand';
import { Survey } from './Survey';
import EmblaCarouselPngs  from './CarouselOfPngs';
import { Profile } from './EditProfileDialog';
import { useNavigate } from 'react-router-dom';

const languages = ["English", "Albanian", "Amharic", "Arabic", "Armenian", "Bengali", "Bosnian", "Bulgarian", "Burmese", "Catalan", "Chinese", "Croatian", "Czech", "Danish", "Dutch", "Estonian", "Finnish", "French", "Georgian", "German", "Greek", "Gujarati", "Hindi", "Hungarian", "Icelandic", "Indonesian", "Italian", "Japanese", "Kannada", "Kazakh", "Korean", "Latvian", "Lithuanian", "Macedonian", "Malay", "Malayalam", "Marathi", "Mongolian", "Norwegian", "Persian", "Polish", "Portuguese", "Punjabi", "Romanian", "Russian", "Serbian", "Slovak", "Slovenian", "Somali", "Spanish", "Swahili", "Swedish", "Tagalog", "Tamil", "Telugu", "Thai", "Turkish", "Ukrainian", "Urdu", "Vietnamese"];

const Home = () => {
    const {userInfo, setUserInfo} = useUser();
    const [isTablet, setIsTablet] = useState(window.matchMedia('(max-width: 600px)').matches);  
    const [url, setUrl] = useState('');
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [post, setPost] = useState(null);
    const [step, setStepInt] = useState(0);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [generatedPng, setGeneratedPng] = useState(null);
    const [zipUrl, setZipUrl] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [generatedPngs, setGeneratedPngs] = useState([]);
    const [generatedDesignId, setGeneratedDesignId] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showSurvey, setShowSurvey] = useState(false);
    const [title, setTitle] = useState('');
    const [continueButton, setContinueButton] = useState(false);

    const [openPostLoginModal, setOpenPostLoginModal] = useState(false);
    const [language, setLanguage] = useState('English');

    const [name, setName] = useState(userInfo?.info?.name);
    const [description, setDescription] = useState(userInfo?.info?.description);
    const [email, setEmail] = useState(userInfo?.email);
    const [token, setToken] = useState(userInfo?.tokens.length > 0 ? userInfo?.tokens[0] : "");
    const [fixedImage, setFixedImage] = useState(userInfo?.info?.profile_pic_cropped || "/images/profilepic.jpg");
    const [website, setWebsite] = useState(userInfo?.info?.website);
    const navigate = useNavigate();

    useEffect(() => {
      if (userInfo?.adadfdr2) {
        navigate('/app-down');
        return;
      }
      if (userInfo && !userInfo.brands || userInfo?.brands?.length === 0) {
        // setOpenPostLoginModal(true);
      }
    }, [userInfo]);


  const generateDesign = async () => {
    setError(null);
    setLoading(true);
    setShowSurvey(userInfo?.showSurvey);
    setGeneratedPng(null);

    let brand_primary_color, brand_secondary_color;
    try {
      if (userInfo.brands && userInfo.brands.length > 0 && userInfo.brands[0].colors && userInfo.brands[0].colors[0].colors && userInfo.brands[0].colors[0].colors.length > 1) {
        brand_primary_color = clr(userInfo.brands[0].colors[0].colors[0]);
        brand_secondary_color = clr(userInfo.brands[0].colors[0].colors[1]);
      }
    } catch (e) {
      console.log('Error getting brand colors: ', e);
    }

    // fixme
    // window.lintrk('track', { conversion_id: 20105330 });
    reqPoll('/generate', 'POST', JSON.stringify({
        template_id: selectedTemplate.id,
        subject: selectedSubject,
        url: url,
        blogpost: post,
        language: language,
        brand_primary_color: brand_primary_color,
        brand_secondary_color: brand_secondary_color,
        html_only: true,
        // content_type: 'research',
        perplexity_recency: "month",
        title: title
    })).then(res => {
        
        // setGeneratedPng(res.url);
        // setGeneratedPngs(res.urls);
        // setGeneratedDesignId(res.design_id);
        // setZipUrl(res.zip_url);
        // setPdfUrl(res.pdf_url);
        setLoading(false);
        navigate('/design/' + res.design_id);
        
    }).catch(error => {
      setGeneratedPng(null);
      setLoading(false);
      console.log('Error generating sample: ', error);
        if (error == "PURCHASE_PLAN") {
          navigate('/choose-plan');
          return;
        }
        setError(error);
    });
  };

  function downloadPng() {
    download(generatedPng);
  }
  function downloadZip() {
    download(zipUrl);
  }
  function downloadPdf() {
    download(pdfUrl)

  }

  function download(url) {
    fetch(url + "&a=" + Math.random())
      .then(response => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'makemybrand-download';
  
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match) filename = match[1];
        } else {
          const urlParts = url.split('/');
          filename = urlParts[urlParts.length - 1].split('?')[0] || filename;
        }
  
        return response.blob().then(blob => ({ blob, filename }));
      })
      .then(({ blob, filename }) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      })
      .catch(error => console.error('Error downloading the file:', error));
  }
  
  
  let width = (!isTablet && step == 0) ? 500 : "100%";
  if (step == 2) width = "fit-content";

  let borderStuff = {
    border: step == 0 ? '1px solid #ccc' : "none",
    p: 2, 
    borderRadius: 2,
  }
  if (isTablet) {
    borderStuff = {}
    width = "70%";
  }

  function setStep(step) {
    if (step == "template-selected") {
      if (selectedTemplate?.previews?.length > 1) {
        if (!userInfo?.name?.length || !userInfo?.description?.length || !userInfo?.profile_pic_cropped?.length) {
          setStepInt("provide-profile");
          return;
        } 
      }
      // if (selectedSubject?.length > 0) {
      //   setTitle(selectedSubject);
      //   setStepInt("generating");
      //   generateDesign();
      //   return;
      // }
      setStepInt("provide-title");
      return;
    }
    setStepInt(step);
  }
  // return (<div>
  //   <NavBar />
  //   <Box sx={{
  //       backgroundColor: 'white', 
  //       margin: step == 1 ? '0px auto' : '30px auto', 
  //       width: width,
  //       overflow: "scroll",
  //       ...borderStuff
  //     }}>
  //       <AiSubjectChooser url={url} setUrl={setUrl} selectedSubject={selectedSubject} setSelectedSubject={setSelectedSubject} setContinueButton={setContinueButton} post={post} setPost={setPost} language={language} setLanguage={setLanguage} />
  //     </Box>
  //   </div>)

  return (
    <div>
      <NavBar />
      <Box sx={{
        backgroundColor: 'white', 
        margin: step == 1 ? '0px auto' : '30px auto', 
        width: width,
        overflow: "scroll",
        ...borderStuff
      }}>
        {step == 0 && (
          <>
            <AiSubjectChooser url={url} setUrl={setUrl} selectedSubject={selectedSubject} setSelectedSubject={setSelectedSubject} setContinueButton={setContinueButton} post={post} setPost={setPost} language={language} setLanguage={setLanguage}  />

            <div style={{
              marginTop: 20,
              display: 'flex',
              justifyContent: 'stretch',
              alignItems: 'center',
              flexDirection: 'row',
              gap: 20
            }}>
            <Select  size="small" value={language} onChange={(e) => setLanguage(e.target.value)} style={{ 
              }}>
                {languages.map((lang, i) => (
                  <MenuItem key={i} value={lang}>{lang}</MenuItem>
                ))}
            </Select>
              
              <Button variant="contained" style={{
                padding: "0.5rem 1rem"
              }} fullWidth onClick={() => {
                setStep("select-template");
              }} disabled={!continueButton}>Select Template</Button>
            </div>
          </>
        )}
        {step == "select-template" && <TemplateGallery setStep={setStep} selectedTemplate={selectedTemplate} setSelectedTemplate={setSelectedTemplate} isOpen={true}/> }

        {step == "provide-title" && (
          <div style={{
            textAlign: 'center',
            overflow: 'scroll',

            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            // width: 600,
            margin: "auto",
            padding: 20
          }}>
            <TextField placeholder="Tips for baking" label="Provide a title for your infographic." value={title} onChange={(e) => setTitle(e.target.value)} fullWidth />
            <Button className="generate-button" variant="contained" sx={{ 
              mt: 2 
            }} fullWidth onClick={() => {
              setStep("generating"); 
              generateDesign();
            }}>Generate</Button>
          </div>
        )}

        {/* using previews length to identify carousels */}
        {step == "provide-profile" && (
          <div style={{
            textAlign: 'center',
            overflow: 'scroll',

            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            // width: width,
            margin: "auto",
            padding: 20,
          }}>
            <p style={{
              marginBottom: 20
            }}>
              <Alert color="primary" severity="info" sx={{ width: '100%', mt: 2 }}>
                For Carousel posts, we need your profile picture, name and a description.
              </Alert>
            </p>
           
              <Profile email={email} setEmail={setEmail} name={name} setName={setName} description={description} setDescription={setDescription} token={token} setToken={setToken} fixedImage={fixedImage} setFixedImage={setFixedImage} showSubscription={false} website={website} setWebsite={setWebsite} userInfo={userInfo} setUserInfo={setUserInfo} />
              
              <Button variant="contained" style={{
                width: "90%",
                marginTop: 20
              }} fullWidth onClick={() => {
                req('/profile', 'POST', JSON.stringify({
                  name, description, website
                })).then(res => {
                  // if (!selectedSubject) {
                    setStep("provide-title"); 
                  // } else {
                  //   setTitle(selectedSubject);
                  //   setStep("generating");
                  //   generateDesign();
                  // }
                });
              }}>Save Profile</Button>
           
          </div>
        )}

        {step == "generating" && (
          <div style={{
            textAlign: 'center',
            overflow: 'scroll',

            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            
            {generatedPngs.length >= 1 && generatedPng && (
              <div style={{ 
              }} > 
                <div>Your design is ready!</div>

                <div style={{
                  display: 'flex',
                  gap: 10,
                  justifyContent: 'center',
                  marginBottom: 10
                }}>
                  <Button variant="contained" sx={{ mt: 2 }} onClick={() => {
                    navigate('/design/' + generatedDesignId)
                  }} style={{
                    textTransform: "none"
                  }}>Edit</Button>

                  <Download pngUrl={generatedPng} zipUrl={zipUrl} pdfUrl={pdfUrl} downloadPng={downloadPng} downloadPdf={downloadPdf} downloadZip={downloadZip} />
                </div>

                {generatedPngs.length > 1 && <EmblaCarouselPngs images={generatedPngs}/>}

                {generatedPngs.length == 1 && generatedPng && (
                  <div style={{ 
                    marginTop: 20,
                    border: '1px solid #ccc',
                  }} >
                    <img src={generatedPng} style={{ height: "100%"  }} /> 
                  </div>)}
              </div>
            )}
            {error && 
              <Alert severity="error" sx={{ width: '100%', mt: 2 }}>
                {toErrorMessage(error)}
              </Alert>}
            <Loading loading={loading} showSurvey={showSurvey} />

          </div>
        )}
      </Box>
      <PostLoginModal open={openPostLoginModal} setOpen={setOpenPostLoginModal} />
      
    </div>
  );
};


function Download({pdfUrl, zipUrl, downloadPng, downloadPdf, downloadZip}) {
  const [anchorEl, setAnchorEl] = useState(null);

  if (pdfUrl && zipUrl) {
    return (
      <>
        <Button variant="contained" sx={{ mt: 2 }} style={{
          textTransform: "none"
        }} onClick={(e) => setAnchorEl(anchorEl ? null : e.currentTarget)}>Download</Button>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
          <MenuItem onClick={() => {
            setAnchorEl(null);
            downloadPdf();
            
          }}>Download PDF</MenuItem>
          <MenuItem onClick={() => {
            setAnchorEl(null);
            downloadZip();
          }}>Download ZIP</MenuItem>
        </Menu>
      </>
    );
  }
  return (
    <Button variant="contained" sx={{ mt: 2 }} style={{
      textTransform: "none",
    }} onClick={downloadPng}>Download</Button>
  )
}

function Loading({loading, showSurvey}) {
  const [showSurveyModal, setShowSurveyModal] = useState(false);

  if (!loading && !showSurveyModal) return;

    return (
      <>
        {loading && (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 10
          }}>
            <div style={{
            }}>
              {showSurvey && (
                <p>
                  Your design is being generated. While you wait, <a href='#' onClick={() => {
                    setShowSurveyModal(true);
                  }}>can we ask you a question?</a>
                </p>
              )}
              {!showSurvey && (
                <p>Please wait while we generate your design...</p>
              )}

            </div>
            <CircularProgress />
          </div>
        )}
       
        <Survey open={showSurveyModal} onClose={() => {
          // submit(); 
          setShowSurveyModal(false);
        }} />
      </>
    )
  }


export default Home;

function clr(color) {
  return `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${color[3]})`;
}

